import React from 'react';
import useNow from '../../hooks/useNow';
import { recentBlocks } from '../../utils/chainClock';
import LatestBlocks from './LatestBlocks';

/**
 * "Latest Blocks" de la portada calculados, sin peticiones: el número y la hora
 * salen del último get_info (que ya hace la página) y el productor del schedule.
 * El nº de transacciones solo se ve en /blocks y en cada bloque.
 */
const LiveLatestBlocks = ({ blockchainInfo, active, count = 8 }) => {
  const now = useNow(500);
  const blocks = recentBlocks(blockchainInfo, active, now, count);
  return (
    <LatestBlocks
      blocks={blocks}
      loading={!blockchainInfo}
      error={null}
      placeholderRows={count}
      footerLink={{ to: '/blocks', label: 'View all blocks →' }}
    />
  );
};

export default LiveLatestBlocks;
